class FullmapItems {
    constructor() {
        this.addListeners();
    }

    addListeners() {    
        
        const list = document.getElementById('fullmapList');

        if (list) {
            const header = document.getElementById('fullmapHeader');
            const arrow = document.getElementById('arrow');
            const items = document.getElementById('fullmapItems');

            header.addEventListener('click', () => {
                items.classList.toggle('fullmap__items--hidden')
                arrow.classList.toggle('arrow-down')
            })
        }

    }


}

export default FullmapItems